export var serviceTypes = {
  tvPackage: 'tvPackage',
  additionalService: 'additionalService',
  antivirus: 'antivirus',
  wifiRouter: 'wifiRouter',
  tvConsole: 'tvConsole',
  tvConsoleForChange: 'tvConsoleForChange',
  additionalTvConsole: 'additionalTvConsole'
};
export var popupAndUpsaleTypes = {
  None: 'None',
  TvInfo: 'TvInfo',
  InternetParam: 'InternetParam',
  AdditionalTVPackages: 'AdditionalTVPackages',
  Antivirus: 'Antivirus',
  WifiRouter: 'WifiRouter',
  Common: 'Common',
  OrderTariffForm: 'OrderTariffForm',
  TvConsoleParameter: 'TvConsoleParameter',
  TvConsoleUpsale: 'TvConsoleUpsale',
  MobileTariff: 'MobileTariff'
};
export var TARIFF_TYPES = /*#__PURE__*/function (TARIFF_TYPES) {
  TARIFF_TYPES[TARIFF_TYPES["internet"] = 0] = "internet";
  TARIFF_TYPES[TARIFF_TYPES["tv"] = 1] = "tv";
  TARIFF_TYPES[TARIFF_TYPES["kit"] = 2] = "kit";
  TARIFF_TYPES[TARIFF_TYPES["phone"] = 3] = "phone";
  TARIFF_TYPES[TARIFF_TYPES["preset"] = 4] = "preset";
  TARIFF_TYPES[TARIFF_TYPES["presetUp"] = 100] = "presetUp";
  TARIFF_TYPES[TARIFF_TYPES["partnerFmc"] = 5] = "partnerFmc";
  return TARIFF_TYPES;
}({});
export var USER_TYPES = /*#__PURE__*/function (USER_TYPES) {
  USER_TYPES[USER_TYPES["FMS_USER"] = 5] = "FMS_USER";
  USER_TYPES[USER_TYPES["FTTB_USER"] = 4] = "FTTB_USER";
  USER_TYPES[USER_TYPES["MOBILE_USER"] = 3] = "MOBILE_USER";
  return USER_TYPES;
}({});